// removed by extract-text-webpack-plugin
module.exports = {"overlay":"popup-module__overlay___1DImm","projectPopup":"popup-module__projectPopup___2XJ_n","iconAndNameRow":"popup-module__iconAndNameRow___3Rmuh","iconAndName":"popup-module__iconAndName___1oNo1","markerIcon":"popup-module__markerIcon___krfk0","closeButton":"popup-module__closeButton___WBKJ1","multipleHubText":"popup-module__multipleHubText___HLulI","chevronIcon":"popup-module__chevronIcon___1KIib"};


//////////////////
// WEBPACK FOOTER
// ./src/components/popup/popup.module.scss
// module id = 351
// module chunks = 0